import { render, staticRenderFns } from "./DigitacionData.vue?vue&type=template&id=3b0c3d3a&"
import script from "./DigitacionData.vue?vue&type=script&lang=js&"
export * from "./DigitacionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports